export const REGISTRY_TABS = {
  COUNTERPARTS: 'counterparts',
  EMPLOYEES: 'employees',
  PRODUCTS: 'products',
} as const;

/**
 * Parametro URL dei tab di pagina. È il contratto letto da sidebar, guard di
 * rotta e ritorno dei form: la toolbar delle tabelle si sincronizza su questo
 * (`filterTabsUrlParam`), non sul `subTab` di default.
 */
export const REGISTRY_TAB_URL_PARAM = 'tab';
